import React from 'react';
import Education from '../../About/Education';
import Skill from '../../About/Skill';
import Contact from '../../Contact/Contact';
import Projects from '../../Projects/Projects/Projects';
import Banner from '../Banner/Banner';

const Home = () => {
        return (
                <div>
                        <Banner />
                        <Projects />
                        {/* <div className="black-bg">
                                <div className="container mx-auto row pt-5">
                                        <div className="col-lg-6">
                                                <Skill />
                                        </div>
                                        <div className="col-lg-6">
                                                <Education />
                                        </div>
                                </div>
                        </div>
                        <Contact /> */}

                </div>
        );
};

export default Home;